import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=08e7edfd&scoped=true&"
import script from "./Foot.vue?vue&type=script&lang=js&"
export * from "./Foot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e7edfd",
  null
  
)

export default component.exports